import { render, staticRenderFns } from "./RegionalMarketForm.vue?vue&type=template&id=a1df7fd2"
import script from "./RegionalMarketForm.vue?vue&type=script&lang=js"
export * from "./RegionalMarketForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports